import { Skeleton, Stack, Typography } from '@mui/material'
import type { FC } from 'react'

export type Props = {
  label: string
  value?: string | number
  loading?: boolean
}

const Detail: FC<Props> = ({ loading = false, label, value }) => (
  <Stack alignItems="center">
    <Typography component="h6" variant="subtitle1">
      {label}
    </Typography>
    {loading ? (
      <span data-testid="app-bar-content-detail-loading">
        <Skeleton variant="text" width={50} />
      </span>
    ) : (
      <Typography>{value}</Typography>
    )}
  </Stack>
)

export default Detail
